import axios from 'axios'
import { api_server } from '../config.js'
const headersObj = {
  'Content-Type': 'application/json;charset=UTF-8',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allowed-Header': 'X-Tenant, x-api-key, access-control-allow-origin',
  mode: 'cors',
}

export const authAPI = axios.create({
  baseURL: `${api_server}/api/auth`,
  headers: headersObj,
})

authAPI.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    apikey: process.env.REACT_APP_APIKEY,
  }
  config.headers = {
    ...config.headers,
    'X-Tenant': 'ai',
  }
  return config
})

export const documentDetailAPI = axios.create({
  baseURL: `${api_server}/api/document`,
  headers: headersObj,
})

documentDetailAPI.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    apikey: process.env.REACT_APP_APIKEY,
  }
  config.headers = {
    ...config.headers,
    'X-Tenant': 'ai',
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allowed-Header': 'X-Tenant, x-api-key, access-control-allow-origin',
    mode: 'cors',
  }
  return config
})

export const documentsAPI = axios.create({
  baseURL: `${api_server}/api/document`,
  headers: headersObj,
})

documentsAPI.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    apikey: process.env.REACT_APP_APIKEY,
  }
  config.headers = {
    ...config.headers,
    'X-Tenant': 'ai',
  }
  return config
})

export const licensingAPI = axios.create({
  baseURL: `${api_server}/user`,
  headers: headersObj,
})

licensingAPI.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    apikey: process.env.REACT_APP_APIKEY,
  }
  config.headers = {
    ...config.headers,
    'X-Tenant': 'ai',
  }
  return config
})



export const usersAPI = axios.create({
  baseURL: `${api_server}/api/users`,
  headers: headersObj,
})

usersAPI.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    apikey: process.env.REACT_APP_APIKEY,
  }
  config.headers = {
    ...config.headers,
    'X-Tenant': 'ai',
  }
  return config
})

export const usersManagementAPI = axios.create({
  // baseURL: `${api_server}/api/user`,
  baseURL: 'http://172.31.47.20:9084/',
  headers: headersObj,
})

usersManagementAPI.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    apikey: process.env.REACT_APP_APIKEY,
  }
  config.headers = {
    ...config.headers,
    'X-Tenant': 'ai',
  }
  return config
})

export const tasksAPI = axios.create({
  baseURL: `${api_server}/api/tasks`,
  headers: headersObj,
})

tasksAPI.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    apikey: process.env.REACT_APP_APIKEY,
  }
  config.headers = {
    ...config.headers,
    'X-Tenant': 'ai',
  }
  return config
})

export const fixFileApi = axios.create({
  baseURL: `${api_server}/api/fix`,
  headers: headersObj,
})

fixFileApi.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    apikey: process.env.REACT_APP_APIKEY,
  }
  config.headers = {
    ...config.headers,
    'X-Tenant': 'ai',
  }
  return config
})

export const crawlAPI = axios.create({
  baseURL: `${api_server}/api/crawl`,
  headers: headersObj,
})

crawlAPI.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    apikey: process.env.REACT_APP_APIKEY,
  }
  config.headers = {
    ...config.headers,
    'X-Tenant': 'ai',
  }
  return config
})

export const addCrwalAPI = axios.create({
  baseURL: `${api_server}/api/crawl`,
  headers: headersObj,
})

addCrwalAPI.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    apikey: process.env.REACT_APP_APIKEY,
  }
  config.headers = {
    ...config.headers,
    'X-Tenant': 'ai',
  }
  return config
})

export const profileAPI = axios.create({
  baseURL: `${api_server}/api/profile`,
  headers: headersObj,
})

usersAPI.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    apikey: process.env.REACT_APP_APIKEY,
  }
  config.headers = {
    ...config.headers,
    'X-Tenant': 'ai',
  }
  return config
})

export const ftpSftpConfigAPI = axios.create({
  baseURL: `${api_server}/api/connection`,
  headers: headersObj,
})

ftpSftpConfigAPI.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    apikey: process.env.REACT_APP_APIKEY,
  }
  config.headers = {
    ...config.headers,
    'X-Tenant': 'ai',
  }
  return config
})

export const trailAPI = axios.create({
  baseURL: `${api_server}/api`,
  headers: headersObj,
})

trailAPI.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    apikey: process.env.REACT_APP_APIKEY,
  }
  config.headers = {
    ...config.headers,
    'X-Tenant': 'ai',
  }
  return config
})
